var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getAppInfo == '')?_c('v-overlay',{attrs:{"value":_vm.getAppInfo == '',"color":"#fff"}},[_c('v-progress-circular',{attrs:{"color":"#223947","indeterminate":"","size":"64"}})],1):_c('router-view')
}
var staticRenderFns = []

export { render, staticRenderFns }